export const recomendacionCapacitacion = {
  "Recomendación": {
    "Persona física": [
      { name: 'RecomendacionFisica.nombre', label: 'Nombre', type: 'text', required: true },
      { name: 'RecomendacionFisica.cedula', label: 'Cédula', type: 'text', required: true },
      { name: 'RecomendacionFisica.direccion', label: 'Dirección', type: 'text' },
      { name: 'RecomendacionFisica.correo', label: 'Correo electrónico', type: 'email', required: true },
      { name: 'RecomendacionFisica.telefono', label: 'Número de contacto', type: 'text' },
      { name: 'RecomendacionFisica.acto', label: 'Nombre del acto administrativo', type: 'text' },
      { name: 'RecomendacionFisica.motivo', label: 'Detalle del motivo de la solicitud', type: 'text' },
      { name: 'RecomendacionFisica.documento', label: 'Documento del acto administrativo', type: 'file' }
    ],
    "Institución pública": [
      { name: 'RecomendacionPublica.institucion', label: 'Nombre de la institución', type: 'text' },
      { name: 'RecomendacionPublica.direccion', label: 'Dirección', type: 'text' },
      { name: 'RecomendacionPublica.telefono', label: 'Teléfono', type: 'text' },
      { name: 'RecomendacionPublica.correo', label: 'Correo electrónico', type: 'email' },
      { name: 'RecomendacionPublica.responsable', label: 'Nombre de la persona responsable', type: 'text' },
      { name: 'RecomendacionPublica.correo_responsable', label: 'Correo de persona responsable', type: 'email' },
      { name: 'RecomendacionPublica.telefono_responsable', label: 'Número contacto responsable', type: 'text' },
      { name: 'RecomendacionPublica.acto', label: 'Nombre del acto administrativo', type: 'text' },
      { name: 'RecomendacionPublica.motivo', label: 'Detalle del motivo de la solicitud', type: 'text' },
      { name: 'RecomendacionPublica.documento', label: 'Documento del acto administrativo', type: 'file' }
    ],
    "Agente económico": [
      { name: 'RecomendacionAgente.empresa', label: 'Nombre de la empresa', type: 'text' },
      { name: 'RecomendacionAgente.direccion', label: 'Dirección', type: 'text' },
      { name: 'RecomendacionAgente.telefono', label: 'Teléfono', type: 'text' },
      { name: 'RecomendacionAgente.correo', label: 'Correo electrónico', type: 'email' },
      { name: 'RecomendacionAgente.responsable', label: 'Nombre de la persona responsable', type: 'text' },
      { name: 'RecomendacionAgente.correo_responsable', label: 'Correo de persona responsable', type: 'email' },
      { name: 'RecomendacionAgente.telefono_responsable', label: 'Número contacto responsable', type: 'text' },
      { name: 'RecomendacionAgente.acto', label: 'Nombre del acto administrativo', type: 'text' },
      { name: 'RecomendacionAgente.motivo', label: 'Detalle del motivo de la solicitud', type: 'text' },
      { name: 'RecomendacionAgente.documento', label: 'Documento del acto administrativo', type: 'file' }
    ]
  },
  "Capacitación": {
    "Persona física": [
      { name: 'capacitacionPersona.nombre', label: 'Nombre', type: 'text' },
      { name: 'capacitacionPersona.cedula', label: 'Cédula', type: 'text' },
      { name: 'capacitacionPersona.direccion', label: 'Dirección', type: 'text' },
      { name: 'capacitacionPersona.correo', label: 'Correo electrónico', type: 'email' },
      { name: 'capacitacionPersona.telefono', label: 'Número de contacto', type: 'text' },
      { name: 'capacitacionPersona.publico', label: 'Público destinatario', type: 'text' },
      { name: 'capacitacionPersona.cantidad', label: 'Cantidad de personas', type: 'number' },
      { name: 'capacitacionPersona.tema', label: 'Tema de interés', type: 'text' },
      { name: 'capacitacionPersona.fechas', label: 'Fechas y horarios', type: 'text' },
      { name: 'capacitacionPersona.lugar', label: 'Lugar de la capacitación', type: 'text' },
      { name: 'capacitacionPersona.documento', label: 'Documento de respaldo', type: 'file' }
    ],
    "Institución pública": [
      { name: 'capacitacionPublica.institucion', label: 'Nombre de la institución', type: 'text' },
      { name: 'capacitacionPublica.direccion', label: 'Dirección', type: 'text' },
      { name: 'capacitacionPublica.telefono', label: 'Teléfono', type: 'text' },
      { name: 'capacitacionPublica.correo', label: 'Correo electrónico', type: 'email' },
      { name: 'capacitacionPublica.responsable', label: 'Persona responsable', type: 'text' },
      { name: 'capacitacionPublica.correo_responsable', label: 'Correo de responsable', type: 'email' },
      { name: 'capacitacionPublica.telefono_responsable', label: 'Teléfono de responsable', type: 'text' },
      { name: 'capacitacionPublica.publico', label: 'Público destinatario', type: 'text' },
      { name: 'capacitacionPublica.cantidad', label: 'Cantidad de personas', type: 'number' },
      { name: 'capacitacionPublica.tema', label: 'Tema de interés', type: 'text' },
      { name: 'capacitacionPublica.fechas', label: 'Fechas y horarios', type: 'text' },
      { name: 'capacitacionPublica.lugar', label: 'Lugar de la capacitación', type: 'text' },
      { name: 'capacitacionPublica.documento', label: 'Documento de respaldo', type: 'file' }
    ],
     "Agente económico": [
      { name: 'capacitacionAgente.empresa', label: 'Nombre de la empresa', type: 'text' },
      { name: 'capacitacionAgente.direccion', label: 'Dirección', type: 'text' },
      { name: 'capacitacionAgente.telefono', label: 'Teléfono', type: 'text' },
      { name: 'capacitacionAgente.correo', label: 'Correo electrónico', type: 'email' },
      { name: 'capacitacionAgente.responsable', label: 'Persona responsable', type: 'text' },
      { name: 'capacitacionAgente.correo_responsable', label: 'Correo de responsable', type: 'email' },
      { name: 'capacitacionAgente.telefono_responsable', label: 'Teléfono de responsable', type: 'text' },
      { name: 'capacitacionAgente.publico', label: 'Público destinatario', type: 'text' },
      { name: 'capacitacionAgente.cantidad', label: 'Cantidad de personas', type: 'number' },
      { name: 'capacitacionAgente.tema', label: 'Tema de interés', type: 'text' },
      { name: 'capacitacionAgente.fechas', label: 'Fechas y horarios', type: 'text' },
      { name: 'capacitacionAgente.lugar', label: 'Lugar de la capacitación', type: 'text' },
      { name: 'capacitacionAgente.documento', label: 'Documento de respaldo', type: 'file' }
    ]
  }
};


export const carrerasRD = [
    "Ingeniería Civil",
    "Ingeniería Industrial",
    "Ingeniería de Sistemas",
    "Ingeniería en Informática",
    "Ingeniería Eléctrica",
    "Ingeniería Electrónica",
    "Ingeniería Mecánica",
    "Ingeniería Química",
    "Ingeniería en Telecomunicaciones",
    "Arquitectura",
    "Diseño Gráfico",
    "Diseño de Interiores",
    "Desarrollo de Software",
    "Ciberseguridad",
    "Ciencia de Datos",
    "Medicina",
    "Odontología",
    "Enfermería",
    "Farmacia",
    "Bioanálisis",
    "Psicología",
    "Nutrición y Dietética",
    "Fisioterapia",
    "Terapia Ocupacional",
    "Radiología",
    "Imagenología",
    "Administración de Empresas",
    "Contabilidad",
    "Mercadeo",
    "Finanzas",
    "Economía",
    "Administración Turística y Hotelera",
    "Negocios Internacionales",
    "Recursos Humanos",
    "Logística y Transporte",
    "Emprendimiento",
    "Derecho",
    "Comunicación Social",
    "Periodismo",
    "Relaciones Públicas",
    "Producción Audiovisual",
    "Educación Inicial",
    "Educación Primaria",
    "Educación Secundaria",
    "Educación Especial",
    "Idiomas Modernos",
    "Literatura",
    "Filosofía",
    "Historia",
    "Sociología",
    "Trabajo Social",
    "Ciencias Políticas",
    "Relaciones Internacionales",
    "Bellas Artes",
    "Diseño de Modas",
    "Diseño Industrial",
    "Música",
    "Teatro",
    "Cine",
    "Fotografía",
    "Biología",
    "Química",
    "Física",
    "Matemáticas",
    "Estadística",
    "Agronomía",
    "Ingeniería Ambiental",
    "Biotecnología",
    "Geología",
    "Teología",
    "Ciencias Militares",
    "Diplomacia y Relaciones Internacionales",
    "Otro"
  ];
  

export const universidadesEInstitutos = [
    // Universidades
    "Universidad Autónoma de Santo Domingo (UASD)",
    "Pontificia Universidad Católica Madre y Maestra (PUCMM)",
    "Universidad Nacional Pedro Henríquez Ureña (UNPHU)",
    "Universidad Iberoamericana (UNIBE)",
    "Universidad APEC (UNAPEC)",
    "Universidad Tecnológica de Santiago (UTESA)",
    "Universidad Católica Santo Domingo (UCSD)",
    "Universidad Católica Nordestana (UCNE)",
    "Universidad Católica del Cibao (UCATECI)",
    "Universidad Central del Este (UCE)",
    "Universidad Abierta para Adultos (UAPA)",
    "Universidad del Caribe (UNICARIBE)",
    "Universidad Federico Henríquez y Carvajal (UFHEC)",
    "Universidad Nacional Evangélica (UNEV)",
    "Universidad Adventista Dominicana (UNAD)",
    "Universidad Interamericana (UNICA)",
    "Universidad de la Tercera Edad (UTE)",
    "Universidad Eugenio María de Hostos (UNIRHEMOS)",
    "Universidad Psicología Industrial Dominicana (UPID)",
    "Universidad Nacional Tecnológica (UNNATEC)",
    "Universidad Católica Tecnológica de Barahona (UCATEBA)",
    "Universidad Agroforestal Fernando Arturo de Meriño (UAFAM)",
    "Universidad Cultural Domínico Americana (UNICDA)",
    "Universidad Odontológica Dominicana (UOD)",
    "Universidad Central Dominicana de Estudios Profesionales (UCDEP)",
    "Universidad Tecnológica del Sur (UTESUR)",
    "Universidad Católica del Este (UCADE)",
    "Universidad Experimental Félix Adam (UNEFA)",
    "Universidad ISA (UNISA)",
    "Universidad Domínico Americano (UNICDA)",
    "Universidad Dominicana (O&M)",
    
    "Academia de Diseño de Santo Domingo (ADSD)",
    
    "Barna Escuela de Negocios (BARNA)",

    "Instituto Tecnológico de Santo Domingo (INTEC)",
    "Instituto Tecnológico de las Américas (ITLA)",
    "Instituto Especializado de Estudios Superiores Loyola (IEESL)",
    "Instituto Tecnológico del Cibao Oriental (ITECO)",
    "Instituto Superior de Formación Docente Salomé Ureña (ISFODOSU)",
    "Instituto Superior para la Defensa (INSUDE)",
    "Instituto Superior de Estudios Especializados en Ciencias Sociales y Humanidades Luis Heredia Bonetti (ISE-LHB)",
    "Instituto Global de Altos Estudios en Ciencias Sociales (IGLOBAL)",
    "Instituto Tecnológico Mercy Jácquez (ITESUMJ)",
    "Instituto Técnico Superior Oscus San Valero (ITSOV)",
    "Instituto Cristiano de Estudios Superiores Especializados (ICES)",
    "Instituto Especializado de Estudios Superiores de la Policía Nacional (IEESPON)",
    "Instituto de Servicios Psicosociales y Educativos (ISPE)",
    "Instituto Superior de Tecnología Universal (INSUTEC)",
    "Instituto Stevens de Tecnología Internacional (SITI)",
    "Academia Superior de Ciencias Aeronáuticas (ASCA)",
    "Instituto OMG",
    "Instituto Técnico de Estudios Superiores en Medio Ambiente y Recursos Naturales (ITESMARENA)",
    "Otro"
  ];
  

export const departmentSiglas = [
    { _id: 1, description: "Abogados Consejo Directivo", siglas: "ACD" },
    { _id: 2, description: "División de Compras", siglas: "CC" },
    { _id: 3, description: "Coordinación del Consejo", siglas: "CCD" },
    { _id: 4, description: "Gestión Técnica del Consejo", siglas: "CCD" },
    { _id: 5, description: "Consejo Directivo", siglas: "CD" },
    { _id: 6, description: "Departamento de Comunicaciones", siglas: "COM" },
    { _id: 7, description: "División de Contabilidad", siglas: "CONT" },
    { _id: 8, description: "Departamento Administrativo", siglas: "DAF" },
    { _id: 9, description: "Dirección Ejecutiva", siglas: "DE" },
    { _id: 10, description: "Departamento de Estudios Económicos", siglas: "DEEM" },
    { _id: 11, description: "Dirección Defensa", siglas: "DEF" },
    { _id: 12, description: "Departamento de Investigaciones", siglas: "INV" },
    { _id: 13, description: "Departamento Jurídico", siglas: "JUR" },
    { _id: 14, description: "Mayordomía", siglas: "MAY" },
    { _id: 15, description: "Oficina de Libre Acceso a la Información", siglas: "OAI" },
    { _id: 16, description: "Dirección de Promoción y Abogacía", siglas: "PA" },
    { _id: 17, description: "Departamento de Planificación", siglas: "PD" },
    { _id: 18, description: "Presidencia", siglas: "PR" },
    { _id: 19, description: "Departamento de Relaciones Interinstitucionales", siglas: "RII" },
    { _id: 20, description: "Departamento de Recursos Humanos", siglas: "RRHH" },
    { _id: 21, description: "Departamento de Seguridad", siglas: "SEG" },
    { _id: 22, description: "División de Servicios Generales", siglas: "SG" },
    { _id: 23, description: "Servicios Generales", siglas: "SG" },
    { _id: 24, description: "División de Tecnología", siglas: "TIC" }
]



export const cargos = [
    "Administrador",
    "Administrador (a)",
    "Administrador (a) General",
    "Administrador General",
    "Administradora",
    "Administradora General",
    "Alcalde",
    "Alcalde (a)",
    "Alcaldesa",
    "Asesor",
    "Asesor (a)",
    "Asesora",
    "Asistente Especial",
    "Comandante",
    "Comandante General",
    "Comisionado",
    "Comisionado (a)",
    "Concejal",
    "Consejero (a)",
    "Consultor (a) Jurídico (a)",
    "Consultor Jurídico",
    "Consultora Jurídica",
    "Contralor",
    "Contralor (a)",
    "Contralor (a) General",
    "Contralor General",
    "Contralora",
    "Coordinador",
    "Coordinador (a)",
    "Coordinador (a) Ejecutivo (a)",
    "Coordinador (a) General",
    "Coordinador General",
    "Coordinadora",
    "Cónsul",
    "Cónsul General",
    "Decano(a)",
    "Defensor",
    "Defensor (a) del Pueblo",
    "Delegado (a)",
    "Delegado Aeroportuario",
    "Director",
    "Director (a)",
    "Director (a) Administrativo (a)",
    "Director (a) Ejecutivo (a)",
    "Director (a) General",
    "Director (a) Interino (a)",
    "Director (a) Nacional",
    "Director Administrativo",
    "Director Ejecutivo",
    "Director General",
    "Director Nacional",
    "Directora",
    "Directora Ejecutiva",
    "Directora General",
    "Directora Nacional",
    "Embajador",
    "Embajador (a)",
    "Embajadora",
    "Encargada",
    "Encargado",
    "Encargado (a)",
    "Encargado (a) Interino (a)",
    "Especialista",
    "Gerente",
    "Gerente General",
    "Gobernador",
    "Gobernador (a)",
    "Gobernadora",
    "Inspector General",
    "Intendente",
    "Jefe",
    "Juez (a) Presidente",
    "Juez Presidente",
    "Miembro",
    "Ministra",
    "Ministro",
    "Ministro (a)",
    "Presidenta",
    "Presidente",
    "Presidente (a)",
    "Presidente (a) del Senado",
    "Presidente de la Comisión",
    "Procurador (a) Adjunto (a)",
    "Procurador (a) General",
    "Procurador (a) General Adjunto (a)",
    "Procurador Fiscal",
    "Procurador General",
    "Procurador General adjunto",
    "Procurador adjunto",
    "Procuradora Fiscal",
    "Procuradora General",
    "Procuradora General adjunta",
    "Procuradora adjunta",
    "RAI",
    "Rector",
    "Rector (a)",
    "Rectora",
    "Regidor (a)",
    "Representante Segunda Sustituta",
    "Secretaria",
    "Secretaria del Concejo",
    "Secretario",
    "Secretario (a)",
    "Secretario (a) Auxiliar",
    "Secretario (a) General",
    "Secretario (a) del Concejo",
    "Secretario General",
    "Secretario del Concejo",
    "Sub-Gerente",
    "Sub-Inspector",
    "Sub-Tesorero Nacional",
    "Subadministrador",
    "Subadministrador (a)",
    "Subadministrador (a) General",
    "Subadministradora",
    "Subcomandante General",
    "Subconsultor",
    "Subconsultor (a)",
    "Subcontralor",
    "Subcontralor (a)",
    "Subdirector",
    "Subdirector (a)",
    "Subdirector (a) Ejecutivo (a)",
    "Subdirector (a) General",
    "Subdirector (a) Nacional",
    "Subdirectora",
    "Subgerente General",
    "Subsecretaria",
    "Subsecretario",
    "Subsecretario (a)",
    "Subtesorero (a) Nacional",
    "Superintendente",
    "Tesorera",
    "Tesorero",
    "Tesorero (a)",
    "Tesorero Nacional",
    "Vicealcalde",
    "Vicealcalde (sa)",
    "Vicealcaldesa",
    "Vicedecano (a)",
    "Vicegobernadora",
    "Viceministra",
    "Viceministro",
    "Viceministro (a)",
    "Vicepresidenta",
    "Vicepresidente",
    "Vicepresidente (a)",
    "Vicerrector",
    "Vicerrector (a)",
    "Vicerrectora",
    "Vocal"
]

export const communicationTypes = [
    {
        _id: 1,
        description: "Externa",
        key: "EXT"
    },
    {
        _id: 2,
        description: "Interna",
        key: "INT"
    }
]

export const communicationReceivedVia = [
    {
        _id: 1,
        description: "Digital",
        key: "digital"
    },
    {
        _id: 2,
        description: "Física",
        key: "personal"
    },
    {
        _id: 3,
        description: "Interna",
        key: "internal"
    }
]

export const communicationsExternalTypes = [
    "ACTO",
    "ACTO DE ALGUACIL",
    "CERTIFICACIÓN",
    "CORRESPONDENCIA",
    "FACTURA",
    "OTROS"
]